/**
 * States of Chemical Species
 *
 * Can't wait for ECMA 6
 */
define(function () {
    var instance = null;
    function SpecieState() {
        this.LIQUID = "l";
        this.SOLID = "s";
        this.GAS = "g";
        this.AQUEOUS = "aq";
    }
    SpecieState.getInstance = function() {
        if(instance === null) {
            instance = new SpecieState();
        }
        return instance;
    };
    return SpecieState.getInstance();
});
